<template>
  <a-modal
    :title="modalTitle"
    :maskClosable="false"
    :visible="showModal"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
    @ok="handleOk"
    okText="提交"
  >
    <a-form layout="horizontal" :form="form">
      <a-form-item
        label="名称"
        :labelCol="{ span: 6 }"
        :wrapperCol="{ span: 16 }"
      >
        <a-input
          placeholder="请输入菜品名称"
          autocomplete="off"
          v-decorator="[
            'name',
            { rules: [{ required: true, message: '名称不能为空!' }] }
          ]"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="菜品类型"
        :labelCol="{ span: 6 }"
        :wrapperCol="{ span: 16 }"
      >
        <a-select
          placeholder="请选择菜品类型"
          v-decorator="[
            'menuType',
            { rules: [{ required: true, message: '请选择菜品类型!' }] }
          ]"
        >
          <a-select-option
            v-for="item in menuTypeList"
            :key="item.id"
            :value="item.id"
            >{{ item.text }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
        <span slot="label">
          菜品标签
          <a-tooltip title="当菜品满足营养套餐需求时为营养菜品，否则为传统菜品">
            <a-icon type="question-circle" style="color:rgb(24, 144, 255)" />
          </a-tooltip>
        </span>
        <a-select
          placeholder="请选择菜品标签（营养/传统）"
          mode="multiple"
          v-decorator="[
            'menuLabel',
            { rules: [{ required: true, message: '请选择菜品标签!' }] }
          ]"
        >
          <a-select-option value="营养">
            营养
          </a-select-option>
          <a-select-option value="传统">
            传统
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="就餐类型"
        :labelCol="{ span: 6 }"
        :wrapperCol="{ span: 16 }"
      >
        <a-select
          placeholder="请选择就餐类型"
          mode="multiple"
          v-decorator="[
            'dinnerType',
            { rules: [{ required: true, message: '请选择就餐类型!' }] }
          ]"
        >
          <a-select-option value="1">
            早餐
          </a-select-option>
          <a-select-option value="2">
            午餐
          </a-select-option>
          <a-select-option value="3">
            晚餐
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="单价"
        :labelCol="{ span: 6 }"
        :wrapperCol="{ span: 16 }"
      >
        <a-input
          placeholder="菜品单价"
          v-decorator="[
            'price',
            {
              rules: [
                { required: true, message: '菜品单价不能为空!' },
                {
                  pattern: /(^[0-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/,
                  message: '菜品单价格式不正确'
                }
              ]
            }
          ]"
        >
          <span slot="prefix" style="color:#999">￥</span>
        </a-input>
      </a-form-item>
      <a-form-item
        label="描述"
        :labelCol="{ span: 6 }"
        :wrapperCol="{ span: 16 }"
      >
        <a-input
          placeholder="请输入菜品描述"
          v-decorator="[
            'desc',
            { rules: [{ required: false, message: '菜品描述可空!' }] }
          ]"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="图片"
        :labelCol="{ span: 6 }"
        :wrapperCol="{ span: 16 }"
      >
        <a-upload
          name="avatar"
          listType="picture-card"
          class="avatar-uploader"
          :showUploadList="false"
          :beforeUpload="beforeUpload"
          @change="handleChange"
          v-decorator="[
            'imgUrl',
            { rules: [{ required: false, message: '图片可空！' }] }
          ]"
        >
          <img v-if="addInfo.imgUrl" :src="addInfo.imgUrl" />
          <div v-else>
            <a-icon type="plus" />
            <div class="ant-upload-text">上传图片</div>
          </div>
        </a-upload>
      </a-form-item>

      <a-form-item v-if="addInfo.id !== undefined">
        <a-input type="hidden" v-decorator="['id', { rules: [] }]"></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
export default {
  data() {
    return {
      imgState: false,
      imgFile: '',
      modalTitle: '新增菜品'
    };
  },
  props: {
    menuTypeList: {
      type: Array,
      default: () => []
    },
    submitType: {
      type: String,
      default: 'add'
    },
    showModal: Boolean,
    confirmLoading: Boolean,
    addInfo: {
      type: Object,
      default: () => {
        return {
          name: "",
          imgUrl: ''
        }
      }
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  methods: {
    handleCancel() {
      this.$emit('cancel')
    },
    handleOk(e) {
      this.$emit("submit", this.form, this.imgFile, this.imgState);
      this.imgFile = ''
    },
    handleChange(file, fileList) {
    },
    beforeUpload(file) {
      getBase64(file, (imgUrl) => {
        this.addInfo.imgUrl = imgUrl;
        this.imgFile = file
      })
      const isImg = file.type.split('/')[0] === 'image'
      if (!isImg) {
        this.$message.error('请选择图片文件!')
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        this.$message.error('图片大小不能超过5M!')
        return false;
      }

      return false;
    }
  },
  watch: {
    addInfo: function (data) {
      setTimeout(() => {
        this.form.setFieldsValue(this.addInfo);
        this.imgState = false
      }, 100);
    },
    submitType: function (data) {
      this.modalTitle = data === 'add' ? '新增菜品' : '修改菜品'
    },
    imgFile: function (data) {
      if (this.submitType === 'edit') {
        this.imgState = !this.imgState
      }
    }

  }
}
</script>
<style lang="less" scoped>
.avatar-uploader /deep/ .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.avatar-uploader img {
  width: 128px;
  height: 128px;
  margin-left: -9px;
  margin-top: -9px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
